import { getTracingHeaders } from '../util/helpers';
import HttpClient from './HttpClient';
import { ConfigState } from '../store/config';
import { AuthState } from '../store/auth';

abstract class ClientAbstract {
  protected httpClient: HttpClient;
  protected config: ConfigState;
  protected auth: AuthState;

  constructor(config: ConfigState, auth: AuthState) {
    const {
      apiUri, universalAccessToken, idtoken, customerToken, traceid,
    } = config;
    const { accessToken, lcId } = auth;

    const token = universalAccessToken || accessToken;
    const tokenType = lcId ? 'Bearer' : 'Access';

    const headers: Record<string, string> = {
      Accept: 'application/json; charset=utf-8',
      Authorization: `${tokenType} ${token}`,
      ...getTracingHeaders(traceid),
    };

    if (idtoken) {
      headers['x-id-token'] = idtoken;
    }

    if (customerToken) {
      headers['x-customer-token'] = customerToken;
    }

    this.httpClient = new HttpClient(apiUri, headers);
    this.config = config;
    this.auth = auth;
  }

  getCustomerInfoFromConfigOrAuth(): { lcId?: string, registerId?: string, spId: string } {
    const {
      universalAccessToken,
      customerToken,
      idtoken,
      registerToken,
      spId,
      lcId,
      registerId,
    } = this.config;

    const forgeRockAuth = (spId
    && !universalAccessToken
    && !registerToken
    && !idtoken
    && !customerToken);

    return forgeRockAuth ? {
      spId,
      lcId,
      registerId,
    } : {
      spId: this.auth.spId,
      lcId: this.auth.lcId,
      registerId: this.auth.registerId,
    };
  }
}

export default ClientAbstract;
